import Repository from "@/repositories/RepositoryFactory";
import groupRepository from "../../repositories/groups";
import gpsDataRepository from "../../repositories/gpsDataRepository";
import APISTATE from "../../enums/APISTATE";

const mockData = {
  rows: [
    {
      reportRowName: "Hjemmetid HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Hjemmetid SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Besøg HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Besøg HV med kode 23 (Minus)",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Besøg SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Besøg SH med kode 23 (Minus)",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Insemineringer HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Insemineringer SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Drægtighedsundersøgelser HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Drægtighedsundersøgelser SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Øvrige behandlinger HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Øvrige behandlinger SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Forgæves besøg HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Forgæves besøg SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Mobiltilkald HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Mobiltilkald SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Ekstra besøg HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Ekstra besøg SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Afhentning af Sæd hos kollega HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Afhentning af Sæd hos kollega SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Donortilkald HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Donortilkald SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Rådgivningstid HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Rådgivningstid SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Anden tid HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Anden tid SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Admin tid HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Admin tid SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Aflevering af sæd HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Aflevering af sæd SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Køretid HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Køretid SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Køretid før 07:15 HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "Køretid før 07:15 SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "DNA HV",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName: "DNA SH",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName:
        "Andet heldagsarbejde a' 8 t. Hverdage og antal timer total",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
    {
      reportRowName:
        "Andet heldagsarbejde a' 8 t. Søn- og helligdage og antal timer total",
      hourlySalaryHV: 0,
      hourlySalarySH: 0,
      driveTimeHV: 0,
      driveTimeSH: 0,
    },
  ],
};

const reports = Repository.get("reports");
const getDateFromMonthYear = ( day, month, year ) => {
  let date = new Date();
  date.setMonth( month );
  date.setFullYear( year );
  date.setDate( day );
  return date;
};
const getLatestDayOfMonth = ( month, year ) => {
  return new Date( year, month + 1, 0 ).getDate();
};
export default {
  namespaced: true,
  state: {
    apiState: APISTATE.LOADED,
    salaryReportList: {},
    salaryDayReportList: {},
    salaryReportFilterYear: undefined,
    salaryReportFilterMonth: undefined,
    salaryReportFilterToYear: undefined,
    salaryReportFilterToMonth: undefined,
    salaryReportFilterEmployeeNumber: 0,
    showYear: false,
    showEmpty: false,
    compareDate: false,
    showToDate: false,
    fromDate: undefined,
    toDate: undefined,
    salaryReportCsv: [],
  },
  mutations: {
    setApiState: (state, apiState) => {
      state.apiState = apiState;
    },
    setSalaryReportList: (state, response) => {
      state.salaryReportList = response;
      console.log( response )
      state.apiState = APISTATE.LOADED;
    },
    setSalaryDayReportList: (state, response) => {
      state.salaryDayReportList = response;
      state.apiState = APISTATE.LOADED;
    },
    setSalaryReportFilterYear: (state, response) => {
      state.salaryReportFilterYear = response;
    },
    setSalaryReportFilterMonth: (state, response) => {
      state.salaryReportFilterMonth = response;
    },
    setSalaryReportFilterToYear: (state, response) => {
      state.salaryReportFilterToYear = response;
    },
    setSalaryReportFilterToMonth: (state, response) => {
      state.salaryReportFilterToMonth = response;
    },
    setSalaryReportFilterEmployeeNumber: (state, response) => {
      state.salaryReportFilterEmployeeNumber = response;
    },
    setShowYear: ( state, showYear ) => {
      state.showYear = showYear;
    },
    setCompareDate: ( state, compareDate ) => {
      state.compareDate = compareDate;
    },
    setShowEmpty: ( state, showEmpty ) => {
      state.showEmpty = showEmpty;
    },
    setShowToDate: ( state, showToDate ) => {
      state.showToDate = showToDate;
    },
    setFromDate: ( state, fromDate ) => {
      state.fromDate = fromDate;
    },
    setToDate: ( state, toDate ) => {
      state.toDate = toDate;
    },
    setSalaryReportCsv: (state, response) => {
      state.salaryReportCsv = response;
    },
  },
  actions: {
    async exportSalaryReportCsv({ commit, dispatch }, dto) {
      try {
        let salaryReportCsv = await reports.exportSalaryReportCsv(dto);
        commit('setSalaryReportCsv', salaryReportCsv);
      }
      catch (error) {
        console.error(error);
        commit("setApiState", APISTATE.ERROR);
      }    
    },
    async addNewLine ( { commit, state }, type ) {
      let salaryReportList = state.salaryReportList;

      let group = 'Diverse';
      switch ( type ) {
        case 'partialSumRows':
          group = 'HandyVik';
          break;
        case 'payrollRows':
          group = 'Øvrige';
          break;
        case 'onAccountSalaryRows':
          group = 'OnAccount';
          break;
      }

      salaryReportList[ type ] = [
        ...salaryReportList[ type ].filter( s => s.identifier !== 'Total' ),
        {
          times: 0,
          reportRowName: '',
          type: 'gange',
          newLine: true,
          rate: 0,
          total: 0,
          isUserDefined: true,
          group: group
        },
        salaryReportList[ type ].find( s => s.identifier === 'Total' ) ];
      commit( "setSalaryReportList", salaryReportList );
    },
    setShowYear ( { commit, dispatch }, showYear ) {
      commit( "setShowYear", showYear );
      dispatch('performLookup');
    },
    setShowEmpty ( { commit }, showEmpty ) {
      commit( "setShowEmpty", showEmpty );
    },
    setShowToDate ( { commit }, showToDate ) {
      commit( "setShowToDate", showToDate );
    },
    setFromDate ( { commit }, dateFrom ) {
      commit( "setFromDate", dateFrom );
    },
    setToDate ( { commit }, toDate ) {
      commit( "setToDate", toDate );
    },
    setCompareDate ( { commit }, compareDate ) {
      commit( "setCompareDate", compareDate );
    },
    async performLookup ( { state, dispatch, rootGetters } ) {
      let fromDate = getDateFromMonthYear(1, state.salaryReportFilterMonth, state.salaryReportFilterYear);
      let toDate = getDateFromMonthYear(
        getLatestDayOfMonth(state.salaryReportFilterMonth, state.salaryReportFilterYear),
        state.salaryReportFilterMonth,
        state.salaryReportFilterYear
      );

      if (state.showToDate) {
        fromDate = state.fromDate;
        toDate = state.toDate;
      }

      if (state.showYear) {
        fromDate = getDateFromMonthYear( 1, 0, state.salaryReportFilterYear );
        toDate = getDateFromMonthYear( 31, 11, state.salaryReportFilterYear );
      }

      let number = state.salaryReportFilterEmployeeNumber;
      if ( !number || number.toString() === '0' ) {
        number = rootGetters.currentUser.number;
      }

      const dto = {
        assistantNumber: number,
        fromDate: fromDate,
        toDate: toDate,
        compareDate: state.compareDate,
        userDefined: state.showToDate
      };
      dispatch('getAllSalaryReport', dto );
    },
    async getAllSalaryReport ( { commit }, dto ) {
      commit("setApiState", APISTATE.LOADING);
      let salaryReports = await reports.getSalaryReport(
        dto.assistantNumber,
        dto.fromDate,
        dto.toDate,
        dto.compareDate,
        dto.userDefined
      );
      salaryReports.partialSumRows.forEach((v, i) => {
        if(i !== salaryReports.partialSumRows.length -1){
          v.style = { color: 'Blue'};
        }
        else{
          v.style = {fontWeight: 'bold'};
        }
      });
      salaryReports.payrollRows.forEach((v, i) => {
        if(i !== salaryReports.payrollRows.length -1){
          v.style = { color: 'Red'};
        } else{
          v.style = {fontWeight: 'bold'};
        }
      });
      salaryReports.averageRows.forEach((v, i) => {
          v.style = { color: 'Green'};
      });
      salaryReports.general.forEach((v, i) => {
        v.style = { color: 'Purple'};
      });
      salaryReports.totalSalaryRows.forEach((v, i) => {
        v.style = {fontWeight: 'bold'};
      });
      commit("setSalaryReportList", salaryReports);
      commit("setApiState", APISTATE.LOADED);
    },
    async getSalaryDayReport({ commit }, dto) {
      commit("setApiState", APISTATE.LOADING);
      try {
        let salaryReports = await reports.getSalaryDayReport(
          dto.assistantNumber,
          dto.fromDate
        );
        commit('setSalaryDayReportList', salaryReports);
      }
      catch (error) {
        console.error(error);
        commit("setApiState", APISTATE.ERROR);
      }
    },
    async setYear({ commit, dispatch }, year) {
      commit("setSalaryReportFilterYear", year);
    },
    setMonth({ commit }, month) {
      commit("setSalaryReportFilterMonth", month);
    },
    setToYear({ commit }, year) {
      commit("setSalaryReportFilterToYear", year);
    },
    setToMonth({ commit }, month) {
      commit("setSalaryReportFilterToMonth", month);
    },
    setEmployeeNumber({ commit }, employeeNumber) {
      commit("setSalaryReportFilterEmployeeNumber", employeeNumber);
    },
    initYearMonth({ commit }) {
      const date = new Date();
      commit("setSalaryReportFilterYear", date.getFullYear());
      commit("setSalaryReportFilterMonth", date.getMonth());
    },    
    async processReportSalaryEmployee({commit, state}, dto){
      commit("setApiState", APISTATE.LOADING);
      await reports.processReportSalaryEmployee(dto).then( async function (){
        commit("setApiState", APISTATE.LOADED);
      });
      
      commit("setApiState", APISTATE.LOADED);
    },    
    async lockReportSalaryEmployee({commit, state}, dto){
      commit("setApiState", APISTATE.LOADING);
      await reports.lockReportSalaryEmployee(dto).then( async function (){
        commit("setApiState", APISTATE.LOADED);
      });
      
      commit("setApiState", APISTATE.LOADED);
    }, 
    async unlockReportSalaryEmployee({commit, state}, dto){
      commit("setApiState", APISTATE.LOADING);
      await reports.unlockReportSalaryEmployee(dto).then( async function (){
        commit("setApiState", APISTATE.LOADED);
      });
      
      commit("setApiState", APISTATE.LOADED);
    },
    async updateReportSalaryEmployee({commit, state}, dto){
      commit("setApiState", APISTATE.LOADING);
      console.log( dto )
      await reports.updateReportSalaryEmployee(dto).then( async function () {
        commit("setApiState", APISTATE.LOADED);
      });
      
      commit("setApiState", APISTATE.LOADED);
    },
  },
  getters: {
    salaryReportCsv(state) {
      return state.salaryReportCsv;
    },
    salaryReportList(state) {
      return state.salaryReportList;
    },
    salaryDayReportList(state) {
      return state.salaryDayReportList;
    },
    salaryReportApiState(state) {
      return state.apiState;
    },
    salaryReportFilterYear(state) {
      return state.salaryReportFilterYear;
    },
    salaryReportFilterMonth(state) {
      return state.salaryReportFilterMonth;
    },
    salaryReportFilterEmployeeNumber(state) {
      return state.salaryReportFilterEmployeeNumber;
    },
    showYear: ( state ) => { return state.showYear; },
    compareDate: ( state ) => { return state.compareDate; },
    showEmpty: ( state ) => { return state.showEmpty; },
    showToDate: ( state ) => { return state.showToDate; },
    fromDate: ( state ) => { return state.fromDate; },
    toDate: ( state ) => { return state.toDate; }
  },
};
